import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import UsersRegisterTable from "./usersRegisterTable";
import { setUserDetailsIsEdit } from "./redux/actions";
import { useDispatch, useSelector } from "react-redux";
import "./index.less";

const UserManager = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    if (user?.permissions?.user_manager?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  return (
    <div className="page-top-div">
      <span className="text-span">users Manager</span>
      <Row className="production-manager-parent-row card-container">
        <Col span={24} className="heading-col">
          <Row align="middle" gutter={[30, 0]}>
            <Col xl={5} xxl={3}>
              <div>
                <span className="heading-span">Users Register</span>
              </div>
            </Col>
            <Col>
              {canUpdate && (
                <Button
                  onClick={() => {
                    navigate("/settings/users-manager/create-user");
                    dispatch(setUserDetailsIsEdit(true));
                  }}
                  icon={<PlusOutlined />}
                  className="add-user-btn"
                  size="middle"
                  style={{ fontSize: "13px", fontWeight: 600 }}
                >
                  USER
                </Button>
              )}
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <UsersRegisterTable canUpdate={canUpdate}/>
        </Col>
      </Row>
    </div>
  );
};

export default UserManager;
